import { memo, useMemo } from "react";

import { type RenderGroupRowCellProps } from ".";
import IacManagementEmptyCellValue from "../../components/CellEmptyValue";
import useIacManagementAnalytics from "../../useIacManagementAnalytics";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementGroupCell from "../components/GroupCell";
import IacManagementTableSpace from "../components/Space";

const IacManagementTableGroupRowCellSpace = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const { analyticPage } = useIacManagementAnalytics();

  const isStackRow = row.__typename === "ManagedEntitiesGroupedByStacks";
  const spaceId = (isStackRow && row.stackSpaceID) || undefined;
  const spaceName = (isStackRow && row.stackSpaceName) || spaceId;

  const spaceFilterAction = useCellFilterAction(ResourcesSuggestions.Space, spaceId || "");
  const actions = useMemo(() => (spaceId ? [spaceFilterAction] : []), [spaceId, spaceFilterAction]);

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      {spaceId ? (
        <IacManagementTableSpace
          columnId={IAC_MANAGEMENTS_TABLE_COLUMNS.SPACE}
          href={`/spaces/root${spaceId}`}
          analyticsPage={analyticPage}
          analyticsTitle="Space name link clicked"
          analyticsProps={{ driftsDetectedCount: row.drifted }}
        >
          {spaceName}
        </IacManagementTableSpace>
      ) : (
        <IacManagementEmptyCellValue />
      )}
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellSpace.displayName = "IacManagementTableGroupRowCellSpace";

export default IacManagementTableGroupRowCellSpace;
